import { HttpParams } from '@angular/common/http';

export function buildHttpParams<T extends object>(obj: T | null | undefined): HttpParams {
  let params = new HttpParams();

  if (!obj) {
    return params;
  }

  Object.entries(obj).forEach(([chave, valor]) => {
    if (valor === null || valor === undefined || valor === '') {
      return;
    }

    if (Array.isArray(valor)) {
      valor.forEach((v) => {
        if (v !== null && v !== undefined) {
          params = params.append(chave, String(v));
        }
      });
    } else {
      params = params.set(chave, String(valor));
    }
  });

  return params;
}
